export const InactivityWarning = ({ onStayLoggedIn, warningSeconds }) => {
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999,
    },
    modal: {
      background: "var(--colour-content-background)",
      color: "var(--colour-content-text)",
      padding: "2rem",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      gap: "1rem",
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2>Session Timeout Warning</h2>
        <p>
          You will be logged out in {warningSeconds} seconds due to inactivity.
        </p>
        <button
          className="button"
          style={styles.button}
          onClick={onStayLoggedIn}
        >
          Stay Logged In
        </button>
      </div>
    </div>
  );
};
